// extracted by mini-css-extract-plugin
export default {"infoContainer":"styles_infoContainer__a8HXf","title":"styles_title__M7S0j","paragraph":"styles_paragraph__qVZQP"};